export const DRAG_RADIUS = 40;
export const INNER_RADIUS = 50;
export const OUTER_RADIUS = 180;
